import enLang from 'antd/es/locale/en_US';
import frLang from 'antd/es/locale/fr_FR';
import deLang from 'antd/es/locale/de_DE';
import itLang from 'antd/es/locale/it_IT';

/** Ant Design locales aligned with supported i18n languages (en, fr, it, de). */
const AppLocale = {
  en: enLang,
  fr: frLang,
  de: deLang,
  it: itLang,
};

export default AppLocale;
